module.exports = __webpack_public_path__ + "new_product_supplier-c646e37a45f2ca72c35986f25b0d2386.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/onboarding/new_product_supplier.png
// module id = 1132
// module chunks = 0 1 2 3 4